import { z } from 'zod';

export const tenantInsightSchema = z
  .object({
    tenant_id: z.string(),
    asset_count: z.number(),
    shared_asset_count: z.number(),
    total_storage_bytes_used: z.number(),
    versions_storage_bytes_used: z.number(),
    variants_storage_bytes_used: z.number(),
  })
  .nullable();

export type InsightKey = 'asset_count' | 'shared_asset_count' | 'total_storage_bytes_used';
